export const LINE_ITEM_PRIORITIES = [...Array(16).keys()].map((i: number): number => i + 1)
